import { render } from "./NConsultingSection.vue?vue&type=template&id=391360e7&scoped=true"
import script from "./NConsultingSection.vue?vue&type=script&lang=js"
export * from "./NConsultingSection.vue?vue&type=script&lang=js"

import "./NConsultingSection.vue?vue&type=style&index=0&id=391360e7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391360e7"]])

export default __exports__